const envSettings = window as any;

class AppConfig {
  static envConfig = envSettings.envConfig;
}

export default AppConfig;